import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  trackNavToLogin,
  trackNavToSignup,
  trackNavToOTP,
  trackNavToHome,
  trackNavToProfile,
  trackNavToTrips
} from 'services/mixpanel';

export const useNavigationTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const fromScreen = document.referrer || 'direct';
    const toScreen = location.pathname;

    switch (toScreen) {
      case '/login':
        trackNavToLogin({
          from_screen: fromScreen,
          to_screen: toScreen,
          screen_index: 0
        });
        break;
      case '/signup':
        trackNavToSignup({
          from_screen: fromScreen,
          to_screen: toScreen,
          screen_index: 0
        });
        break;
      case '/password-otp':
        trackNavToOTP({
          from_screen: fromScreen,
          to_screen: toScreen,
          screen_index: 0
        });
        break;
      case '/':
        trackNavToHome({
          from_screen: fromScreen,
          to_screen: toScreen
        });
        break;
      case '/profile':
        trackNavToProfile({
          from_screen: fromScreen,
          to_screen: toScreen
        });
        break;
      case '/trips':
        trackNavToTrips({
          from_screen: fromScreen,
          to_screen: toScreen,
          booking_type: 'standard',
          has_flight_number: false,
          has_chauffeur_note: false,
          timestamp: Date.now(),
          user_id: localStorage.getItem('user_id') || ''
        });
        break;
    }
  }, [location]);
}; 